/* eslint-disable no-unused-vars */
export enum EyebrowTypes {
  DARKER = 'darker',
  MID = 'mid',
  LIGHTER = 'lighter',
}
